<template>
  <div class="container">
    <div class="wrap">
      <div class="box-con">
         <div class="title">视频教程</div>
         <div class="video-wrap z-flex z-flex-between">
          <div class="video-item" v-for="(item, index) in videoList" :key="index">
            <video class="video" ref="video" controls @play="handlePlay($event, index)">
              <source :src="item.video">
            </video>
            <div class="v-title">{{ item.title }}</div>
          </div>
         </div>
      </div>
      <div class="box-con box-con-qa">
        <div class="title">使用文档</div>
        <el-collapse class="qa-list">
          <el-collapse-item :title="item.title" v-for="(item, index) in userDocList" :key="index">
            <div class="answer" v-html="item.content"></div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="box-con box-con-qa">
        <div class="title">常见问题</div>
        <el-collapse class="qa-list">
          <el-collapse-item :title="item.question" v-for="(item, index) in QAList" :key="index">
            <div class="answer" v-html="item.answer"></div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
      videoList:[
        {
          video:'https://videoqtclub.pai2345.com/10543799174f71ef80855017e1f80102/f54286e6d16144a59b43d241e240ac94-b6b97cbdb0da7cc8daa710a7b4c3f51c-sd.mp4',
          title:'文生图',
        },{
          video:'https://videoqtclub.pai2345.com/800b4799174f71ef827a0675b3ed0102/c2cc86166d334a0cb939459caafce002-8b0a6b49d0dba790c42d0615550cc783-sd.mp4',
          title:'快捷生图',
        },{
          video:'https://videoqtclub.pai2345.com/500167a9174f71ef81314531859c0102/1ff441971e634e15bb0e96de0aa86ab6-76c410aae1948b2e36c71b404e8d510f-sd.mp4',
          title:'脸部替换',
        },{
          video:'https://videoqtclub.pai2345.com/4002b5171c9871efa3b25017e1f80102/c1c8b2c70aba4fb88e0450cbbf4759f1-70aac7a4cfde5641a9e211418d755e07-sd.mp4',
          title:'条件生图（上）',
        },{
          video:'https://videoqtclub.pai2345.com/00f5b1171c9871efa2815017f1e80102/852a9b74be6a49c0af6f29d0fd5d6ee2-d8cb83c7a95a6b4fd71a176b2ce151c0-sd.mp4',
          title:'条件生图（中）',
        },{
          video:'https://videoqtclub.pai2345.com/30f9af171c9871efa3b25017e1f80102/3848114fbbff428b932619ea883924ea-29e4e394c69485f853900ef0d0e3b080-sd.mp4',
          title:'条件生图（下）',
        },{
          video:'https://videoqtclub.pai2345.com/40763099174f71ef8e5d5420848c0102/3e030671a80a48b493b810448d06ea2a-5e31d79dd74f586760c9fd0cc813b07d-sd.mp4',
          title:'高清修复',
        },{
          video:'https://videoqtclub.pai2345.com/90504299174f71ef8d210764b3ec0102/bd82102331844babb3e90782f97e0835-898465f603c0dce86e201936345c6c56-sd.mp4',
          title:'智能抠图',
        },{
          video:'https://videoqtclub.pai2345.com/10e33499174f71efa05c5017f0f90102/80a7f69f03ad494482de20ff6ac465c4-330abe20cdefcea07298329c38a569c6-sd.mp4',
          title:'黑白上色',
        },
      ],
      curPlayingIndex: null,
      userDocList:[
        {
          title:'文生图',
          content:`<p><strong>什么是文生图？</strong></p><p><span style="font-family: 微软雅黑;">为了更有效的引导AI，即通过提供文字描述去生成图片。这种用来指导模型的信息，称之为提示词（Prompt）。可以将其理解为是人类与AI沟通的桥梁。</span></p><p><span style="font-family: 微软雅黑;">我们通过智能化设计允许直观方便地使用中文进行提示词的输入，进行以文生图的AI图像创作。</span></p><p><span style="font-family: 微软雅黑;"> </span></p><p><strong>文生图创作步骤：</strong></p><p><strong>第一步.选择模型 </strong></p><p><span style="font-family: 微软雅黑;">首先按照你想要创作的题材内容对用选择一个模型。如果你不确定创作某种类型的照片，可以选择：通用模型或者写实摄影模型。点击“更多”可选择更多类别的模型。</span></p><p><img style="width:400px" src="https://dy-allimage.oss-cn-hangzhou.aliyuncs.com/uploads/a59/97a/a5997a0ad7541657a741d2a35cc5cc99.png" alt="" data-href="" style=""/></p><p style="text-align: center;"><span style="font-family: 微软雅黑;"> </span></p><p><strong>第二步.艺术家风格 </strong></p><p><span style="font-family: 微软雅黑;">想呈现的风格和情绪表达，选择艺术家的名字可以实现不同流派与风格的摄影艺术作品，从而模拟不同艺术家的摄影风格。如果对图像风格有要求，选择一个艺术家，会比单纯使用许多提示词去描述画面更快更好。选择对应的艺术家风格，可以简化创作过程，创作出别具风格的影像作品。</span></p><p><img  style="width:400px" src="https://dy-allimage.oss-cn-hangzhou.aliyuncs.com/uploads/8d5/300/8d5300fa623e11286622c807b1666422.png" alt="" data-href="" style=""/></p><p><span style="font-family: 微软雅黑;">注意：艺术家风格不是必选项！！！如果你不想模拟他人风格，可以不选择艺术家，仅选择对应题材的模型去文生图即可。</span></p><p><span style="font-family: 微软雅黑;"> </span></p><p><strong>第3步.生成数量 </strong></p><p><span style="font-family: 微软雅黑;">自行选择生成1-4张图片。</span></p><p><strong>第4步.图片比例和大小</strong></p><p><span style="font-family: 微软雅黑;">自行选择想要生成图片的构图比例，或者在“自定义”中，自行输入长宽比例。</span></p><p><strong>第5步.输入提示词</strong></p><p><span style="font-family: 微软雅黑;">输入你要创作的内容的文字描述。</span></p><p><span style="font-family: 微软雅黑;"> </span></p><p><span style="font-family: 微软雅黑;"> </span></p><p><strong>提示词两种写法：1.自然语言 &nbsp; 2.词组形式</strong></p><p><strong>第一种方法，自然语言：一个黑色头发女孩在跳舞</strong></p><p><strong>第二种方法，词组形式：一个女孩，黑色头发，跳舞</strong></p><p><strong> </strong></p><p><span style="font-family: 微软雅黑;">*提示词不是越多越好，过量的提示词可能会引起模型的混淆，影响出图效果。重要的是找到平衡，既要足够详细以引导AI，又要避免过度复杂化。</span></p><p><img src="https://dy-allimage.oss-cn-hangzhou.aliyuncs.com/uploads/0e9/5b3/0e95b36b8785b51fd6a8a38a582297a4.png" alt="" data-href="" style=""/></p><p><span style="font-family: 微软雅黑;">*我们优化了提示词与模型的组合，即使你的输入随便一句话、一个词或者一个字，只要选择了对应题材的模型，依旧可以为你生成效果不错的图片，如果你还选择了某个艺术家风格，生成的作品就更具独特艺术风格。</span></p><p><img src="https://dy-allimage.oss-cn-hangzhou.aliyuncs.com/uploads/214/a42/214a42b82e8ca90246f39bbb317ce424.png" alt="" data-href="" style=""/></p><p><span style="font-family: 微软雅黑;">*不过丰富的提示词可以更好的控制最终出图效果，在后期微调中，也可以快速修改和验证特定关键词对出图结果的影响。</span></p><p><span style="font-family: 微软雅黑;">*如果你不会编辑提示词，可以先输入主体和环境等最重要的文字，例如：一个美女，在花海。再点击“提示词优化”工具，AI可快速构建出高效的提示词组合。</span></p><p><span style="font-family: 微软雅黑;"> </span><img src="https://dy-allimage.oss-cn-hangzhou.aliyuncs.com/uploads/b1c/2b1/b1c2b1cca76aa2e31822928259ade6e6.png" alt="" data-href="" style=""/></p><p><span style="font-family: 微软雅黑;">*如果输入提示词，生成出来的图没有出现你描述的内容。例如，你输入：一个金发女孩在睡觉。结果没出现金发，也没在睡觉。则可以多次重复提示词，例如：一个金发女孩在睡觉，金发女孩，金发女孩在睡觉，睡觉，睡觉，金发，金发女孩在睡觉。多次重复关键词语，即加大了提示词的权重，十分有效。</span></p><p><span style="font-family: 微软雅黑;"> </span></p><p><strong>万能提示词公式：</strong></p><p><span style="font-family: 微软雅黑;">一条有效的提示词，就如同是在对AI布置一个任务。如果指令含糊不清，比如仅仅说“设计一张图”，而不具体说明要素和用途，那么结果往往难以预料。因此，详细而具体的指令能够极大提升成果的质量和符合度。</span></p><p><span style="font-family: 微软雅黑;">例：提示词仅仅输入“一个女孩”，对于画面中女孩着装、场景、镜头角度等内容都没有提及，AI只能自行发挥，因此生成的画面不一定符合我们的需要。</span></p><p><span style="font-family: 微软雅黑;">当我们加入其他更多的内容与艺术氛围的描述词，画面会稳定很多，也会更加接近我们需要的内容。</span></p><p><strong>一个理想的提示词公式包括：主体内容、环境背景、构图视角、光线，色彩，画面质量，艺术风格等元素，每一部分都对绘图结果有着不同程度的影响。</strong></p><p><img src="https://dy-allimage.oss-cn-hangzhou.aliyuncs.com/uploads/43b/677/43b677a9f1aebcd5a977b26e60443ff4.png" alt="" data-href="" style=""/></p><p><span style="color: rgb(237, 125, 49); font-family: 微软雅黑;">完整提示词示例：一个中国女孩，黑色的长头发，在花海中开心的瞬间，半身构图，逆光的光线，完美的色彩搭配，梦幻般的电影感氛围，浪漫主义极简风格，高质量的摄影照片，详细的细节，国际摄影大师拍摄的杰作，国家地理摄影获奖佳作。</span></p><p><span style="font-family: 微软雅黑;"> </span></p><p><span style="font-family: 微软雅黑;">*公式只是参考，并非每次编写提示词我们都要包含所有内容，实践中，先确定主体内容对出图效果的影响，再根据个人需求进行细节优化。</span></p><p><span style="font-family: 微软雅黑;"> </span></p><p><span style="font-family: 微软雅黑;">1. 主体内容：描述画面的主要内容，比如人或者动物，人物的着装、表情，动物的毛发、动作，物体的材质等。 </span></p><p><span style="font-family: 微软雅黑;">2. 环境背景：设定周围的场景和辅助元素，比如天空的颜色、四周的背景氛围、环境的灯光、画面色调等，这一步是为了渲染画面氛围，凸显图片的主题。</span></p><p><span style="font-family: 微软雅黑;">3. 构图视角：描述画面的镜头和视角，如特写，全景，俯拍还是仰拍，全身还是半身等，控制画面的构图词汇。</span></p><p><span style="font-family: 微软雅黑;">4. 画面质量：增强画面表现力的常用词汇，例如加入详细的细节、摄影画质、电影感、摄影杰作、获奖的佳作等词汇。 </span></p><p><span style="font-family: 微软雅黑;">5. 艺术风格：描述画面想呈现的风格和情绪表达，比如加入艺术家的名字、艺术手法、年代、国家地理摄影风格、马格南摄影风格等等词汇。 </span></p><p><span style="font-family: 微软雅黑;"> </span></p><p><span style="font-family: 微软雅黑;">一键同款：如果觉得编写提示词过于复杂，可以在“广场”中寻找灵感图像，点击“一键同款”，一键复用已有的参数和提示词，简化创作过程。</span></p><p><img style="width:350px" src="https://dy-allimage.oss-cn-hangzhou.aliyuncs.com/uploads/f4e/aa0/f4eaa0c469f323445ac2e3a4a876e6a0.png" alt="" data-href="" style=""/></p><p><span style="font-family: 微软雅黑;"> </span></p><p><br></p>`,
        },{
          title:'条件生图',
          content:`<p style="text-align: left;"><span style="font-family: 宋体;">什么是条件生图？</span></p><p style="text-align: left;"><span style="font-family: 宋体;"> </span></p><p style="text-align: left;"><span style="font-family: 宋体;">允许用户上传一张图片，AI会识别该图片的线条、轮廓、深度等信息，用户再输入提示词，让AI依据提示词和原图的内容，去重新创作一张具有原图结构特征的新画面。</span></p><p style="text-align: left;"><img src="https://dy-allimage.oss-cn-hangzhou.aliyuncs.com/uploads/c50/b61/c50b611496bcdd2b590d3c79fe819647.png" alt="" data-href="" style=""></p><p style="text-align: left;"><span style="font-family: 宋体;">我们在条件生图中提供了六种不同的方案，让用户实现上传自己的图片去识别并重新创作。</span></p><p style="text-align: left;"><span style="color:  rgb(237, 125, 49); font-family: 微软雅黑;">特别提示：</span></p><p style="text-align: left;"><span style="color:  rgb(237, 125, 49); font-family: 微软雅黑;">1.上传的图片，主体要清晰与明确，画面内容不要太复杂，主体不要太小。</span></p><p style="text-align: left;"><span style="color:  rgb(237, 125, 49); font-family: 微软雅黑;">2.根据画面的内容去描述提示词，需描述主体，环境，天气、氛围、风格等关键词去让AI参考原图改变作品风格。</span></p><p style="text-align: left;"><span style="font-family: 宋体;"> </span></p><p><strong>边缘检测、图像重绘、线稿细化</strong><span style="font-family: 宋体;">，这三</span>个功能都是辨识输入图像的边缘信息，能从所上传的图片中提取出原图的<span style="font-family: 宋体;">不同精度的</span>轮廓，随后根据指定提示词生成与原图构图一致的新画面<span style="font-family: 宋体;">。</span></p><p><img src="https://dy-allimage.oss-cn-hangzhou.aliyuncs.com/uploads/141/6b7/1416b77f4b7b883f9a5aa2c119778b7e.png" alt="" data-href="" style=""/></p><p style="text-align: left;"><strong>姿态识别：</strong></p><p style="text-align: left;">上传人物图片用作参考图，识别图片中人物的姿势与动态，再通过提示词修改人物服装与环境特征，复刻原图人物姿势。</p><p>· <span style="font-family: 宋体;">姿势识别可以实现对人体动作和表情特征的精准控制，不仅可以生成单人的姿势，还可以生成多人的姿势。</span></p><p>· <span style="font-family: 宋体;">姿态识别能够识别人体关键结构点如头部、肩部、手肘、膝部等，同时忽略服饰、发型和背景的细节，确保姿势和表情的真实再现。</span></p><p><img src="https://dy-allimage.oss-cn-hangzhou.aliyuncs.com/uploads/19a/2c1/19a2c1bbd4a88e2d1c41e43ecff5999e.png" alt="" data-href="" style=""/><span style="font-family: 宋体;"> </span></p><p style="text-align: left;"><span style="font-family: 宋体;">注意：此功能仅识别画面中以人物为主的图片，不能识别景物或动物。</span></p><p style="text-align: left;"> </p><p style="text-align: left;"><strong>参考生成：</strong></p><p>· <span style="font-family: 宋体;">将上传图片作为基础，结合提示词和参考图中的图像信息进行综合考虑并重绘图像，能更好地保护图片的原貌并改变画面风格。</span></p><p style="text-align: left;"><strong>深度检测：</strong></p><p>· <span style="font-family: 宋体;">深度检测可从图像中提取出物体的前景和背景关系，创建深度图，并应用于图像绘制中。因此，当需要明确画面中物体的前后层次时，深度检测可以作为一个有力的辅助工具。</span></p><p><img src="https://dy-allimage.oss-cn-hangzhou.aliyuncs.com/uploads/274/e13/274e134d67d184bd8044ded6c5a30054.png" alt="" data-href="" style=""/></p>`,
        },{
          title:'快捷生图',
          content:`<p>通过“风格设置”中便捷的风格选择，只需要简单输入提示词，能实现所选风格的高质量出图。</p>`,
        },{
          title:'高清修复',
          content:`<p>对质量较低的图片进行细节与清晰度的修复，例如人像增强，模糊图变清晰，老照片清晰化。</p>
          <p>可适当增强图像画质，增加图片的像素，让您的照片获得更佳的视觉体验。</p>`,
        },{
          title:'黑白上色',
          content:`<p>给图片填充颜色，非常适合修复一些黑白老旧照片。但无法保证颜色准确出现特定位置上，可能会出现相互污染的情况。对人物图片上色会出现肤色较红的现象，可以上色完成后，运用其他调色软件对上色后的图像色彩与饱和度进行修改。</p>`,
        },{
          title:'脸部替换',
          content:`<p> 换脸神器有着无与伦比的准确性。我们先进的AI技术能够将你的奇思妙想转化为栩栩如生的高清影像，全程无缝衔接，带来令人叹为观止的逼真效果。</p>
          <p>&nbsp;</p>
          <p>步骤1：上传照片或选择人物模板</p>
          <p>上传你想要编辑的照片作为源图像，为了获得最佳效果，请确保图像清晰且光线充足。或者在平台提供的脸部模板中选择一个人物进行换脸。</p>
          <p>&nbsp;</p>
          <p>步骤2：选择要换脸的人脸</p>
          <p>选择并上传你想要替换人脸的图片。</p>
          <p>&nbsp;</p>
          <p>步骤3：预览和下载</p>
          <p>点击立即预览换脸结果，满意即可下载生成的图像。</p>
          <p>&nbsp;</p>
          <p>换脸是否安全？</p>
          <p>我们有着可靠的隐私保护和严格的安全措施，用它进行免费换脸很安全。我们不会保存用户上传的照片或生成的换脸图片。其隐私政策透明，保证不会跟踪或分析用户行为。</p>
          <p>&nbsp;</p>
          <p>与名人换脸合法吗？</p>
          <p>与名人换脸或使用他们的照片换脸可能会引起法律和道德问题。使用名人照片的法律在不同的司法管辖区可能会有所不同。某些情况下，换脸可能需要获得名人或其代表的许可。</p>`,
        },{
          title:'智能抠图',
          content:`<p>一键上传图片，通过智能识别去除图片背景，生成PNG图片。</p>
          <p>智能检测图像中的前景主体并识别轮廓，实现精细化背景分割抠图，一键抠出人像、商品、动物、图章等。</p>
          <p>可以精确识别需要保留的主体并移除多余背景，让抠图更加简单、便捷。</p>`,
        },{
          title:'如何下载高清图片？',
          content:`<p>点击网站"我的创作”，在图片上点击“下载”，即可下载PNG格式的无压缩图片，而不是点击图片右键去下载图片。</p>
          <p>点击网站"我的创作”，勾选多张图片，可以进行批量下载，批量下载后的文件是.zip的压缩包，解压后可查看批量下载的多张图片。</p>`,
        },{
          title:'网站上的“广场”有什么作用?',
          content:`<p>在网站的“广场”栏目中，展示了众多用户的AI作品，大家可以在其中欣赏与学习他人的优秀创意，并从中汲取灵感。</p>
          <p>一键同款：如果觉得编写提示词过于复杂，可以在“广场”栏目中，点击你喜欢的图片，图片的右上角会出现“同款”，点击“同款”，一键复用已有的参数和提示词，进行同款创作，简化创作过程。</p>`,
        },
      ],
      QAList:[
        {
          question:'我都可以用AI影像百宝箱做什么？',
          answer:`
            <p>AI影像百宝箱，全民艺术创作平台，提供创作的无限可能！在AI影像百宝箱，您无需专业技能，只需描述您想要创作的画面，借助丰富的模型库和专业级的设置功能，即可快速生成大量高质量作品，充分满足您的个性化需求。</p>
            <p>AI影像百宝箱会成为你无尽的灵感泉源和强大的艺术伙伴，将是你的高效设计利器，您将以最小的努力创造出最富有创意的图像。</p>
            <p>AI影像百宝箱也可以为您提供丰富多样的视觉素材，使您的内容更具吸引力，或者作为您的创新艺术实验室，让你探索人工智能与艺术的交融，激发创新思维。</p>
            `,
        },{
          question:'AI影像百宝箱适合哪些人使用？',
          answer:`
            <p>无论您是初学者还是专业人士，都能在AI影像百宝箱中找到适合自己的AI影像创作方式和独特风格。</p>
            <p>我会拥有创作作品的版权吗，是否可以将自己或他人的作品用于商业用途？</p>
            <p>您在AI影像百宝箱所生成内容的知识产权归属于您，官方不禁止您将自己或他人作品用作商业用途，但请注意将他人的作品用于商业用途时需获得对方授权，官方不对进行商业用途时造成的相关风险负责，您需要自行承担相关风险及责任。</p>
          `,
        },{
          question:'我可以同时在多少个设备上登录账号？',
          answer:`
            <p>AI影像百宝箱允许一个账号同时在1个终端设备登录</p>
          `,
        },{
          question:'我全年可以创作多少作品？',
          answer:`
            <p>普通用户可以同时提交2个任务并执行1个任务，全年可以创作4000个之内的作品。</p>
          `,
        },{
          question:'AI影像百宝箱的会员定价含税吗？是否可以开具发票？',
          answer:`
            <p>AI影像百宝箱的会员定价为含税价格，如您需要开具发票，请将您的账号信息、付款记录、开票信息发送给客服。</p>
          `,
        },{
          question:'我可以取消购买的会员套餐吗？',
          answer:`
            <p>VIP会员服务是网络商品和虚拟商品，会员费用是您所购买的会员服务所对应的网络商品价格，而非预付款或者存款、定金、储蓄卡等性质， VIP会员服务一经开通后不可退款（如因VIP会员服务存在重大瑕疵导致您完全无法使用等AI影像百宝箱的功能。属于违约情形、本协议另有约定、法律法规要求必须退款等除外）。</p>
          `,
        },
      ],
    };
  },
  computed: {
    
  },
  mounted() {

  },
  methods: {
    handlePlay(event, index) {
      const videoElement = this.$refs.video.length; 
      if (videoElement > 0) {
        for (let i = 0; i < videoElement; i++) {
          if (i == index) { 
            this.$refs.video[i].play();
            if (this.$refs.video[i].requestFullscreen) {
              this.$refs.video[i].requestFullscreen()
            } else if (this.$refs.video[i].mozRequestFullScreen) {
              this.$refs.video[i].mozRequestFullScreen()
            } else if (this.$refs.video[i].msRequestFullscreen) {
              this.$refs.video[i].msRequestFullscreen()
            } else if (this.$refs.video[i].oRequestFullscreen) {
              this.$refs.video[i].oRequestFullscreen()
            } else if (this.$refs.video[i].webkitRequestFullscreen) {
              this.$refs.video[i].webkitRequestFullScreen()
      }
          } else {
            this.$refs.video[i].pause();
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container{
  overflow: auto;
}
.wrap{
  width: 1380px;
  margin: 0 auto;
}
.box-con{
  padding:40px 0;
  box-sizing:border-box;
  // background: $colorBgLight;
  .title{
    text-align:center;
    font-size:28px;
    margin-bottom:20px;
  }
  .content{
    ::v-deep p{
      margin:10px 0;
    }
    ::v-deep img{
      max-width:100%;
    }
    ::v-deep video{
      width:100%;
    }
  }
  .video-wrap{
    width: 100%;
    margin-bottom: 30px;
    align-items: flex-start;
    .video-item{
      width:32%;
      margin-top: 30px;
      cursor: pointer;
      .video{
        width:100%;
      }
      .v-title{
        text-align: center;
        margin-top: 15px;
      }
    }
  }
}
.box-con-qa{
  background: $colorBgLight;
  border-radius: 10px;
  margin-bottom: 40px;
}
::v-deep .qa-list{
  margin: 40px 80px;
  border-color: #444;
  .el-collapse-item__header{
    background: none;
    color: #fff;
    font-size: 18px;
    height: inherit;
    line-height: inherit;
    padding:20px 0;
    border-color: #444;
  }
  .el-collapse-item__wrap{
    background:$colorBgLight;
    border-color: #444;
  }
  .el-collapse-item__content{
    color: #eee;
    font-size: 16px;
    padding: 15px;
    .answer{
      p{
        color: #e5e5e5;
        font-size: 16px;
        margin: 10px 0;
      }
      img{
        max-width: 100%;
        height: auto;
      }
    }
  }
}
@media (max-width:1400px){
  .wrap{
    width: 100%;
    
  }
}
</style>
